"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_CODECS = exports.BSONCodec = exports.JSONCodec = void 0;
const defs = __importStar(require("../definitions"));
const bson = __importStar(require("bson"));
exports.JSONCodec = {
    encode: (data) => JSON.stringify(data),
    decode: (data) => {
        let raw;
        if (data instanceof ArrayBuffer) {
            const decoder = new TextDecoder('utf-8');
            raw = decoder.decode(data);
        }
        else {
            raw = data.toString();
        }
        return JSON.parse(raw);
    }
};
exports.BSONCodec = {
    encode: (data) => {
        return bson.serialize(data, {
            ignoreUndefined: true
        });
    },
    decode: (data) => {
        return bson.deserialize(data, {
            promoteBuffers: true
        });
    }
};
exports.DEFAULT_CODECS = {
    [defs.ContentType.JSON]: exports.JSONCodec,
    [defs.ContentType.BSON]: exports.BSONCodec
};
